import React from 'react';
import { CheckSolidIcon, TimesSolidIcon } from '../../../icons/icons';

type Props = {
  value: boolean;
};

export const TrueOrFalseIcon = ({ value }: Props) =>
  value ? <CheckSolidIcon /> : <TimesSolidIcon />;
